export const PUBLIC_TYPE_FEATURE_FLAG = 'ehr-show_risk_public_type_information'

const showPublicType = (_, __, ___, rootGetters) => {
  return rootGetters['featureConfig/getValue'](PUBLIC_TYPE_FEATURE_FLAG)
}

export default {
  showPublicType
}
